import { directive as onClickaway } from 'vue-clickaway';
import { MEDIA } from '@/helpers/variables';
import _ from 'lodash';
import { routeToProduct } from '@/helpers';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'HeaderSearch',
  components: {},
  directives: {
    onClickaway: onClickaway
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MEDIA,
      querySearch: '',
      isSearchLoading: false,
      isShowDropdown: false,
      searchResultData: { news: [], products: [] }
    };
  },
  created() {},
  mounted() {},
  watch: {},

  computed: {
    ...mapGetters(['currentLanguage']),
    ...mapGetters({
      appSize: 'app/size'
    }),
    langPrefix() {
      return this.currentLanguage?.urlPrefix ? this.currentLanguage.urlPrefix + '/' : '';
    }
  },
  methods: {
    ...mapActions({
      fetchSearchItems: 'search/GET_SEARCH_LIST'
    }),
    routeToProduct: routeToProduct,
    onClickSearchAway() {
      this.querySearch = '';
      this.$emit('toggle', false);
    },
    onChangeSearch() {
      this.sendRequest();
    },
    sendRequest: _.debounce(function () {
      if (this.querySearch.length > 2) {
        this.fetchResults();
      }
    }, 500),
    async fetchResults() {
      this.isSearchLoading = true;
      this.searchResultData = await this.fetchSearchItems(this.querySearch);
      this.isSearchLoading = false;
    },
    onClickSearch() {
      if (this.appSize.w <= MEDIA.M1024) {
        this.$emit('toggle', !this.isShow);
      }
    },
    onSetFocusField(status) {
      this.isShowDropdown = status;
    },
    getOtherItemRoute(item) {
      let { pageSlug, slug } = item;
      pageSlug = pageSlug === 'video-materialy' ? 'video' : pageSlug;
      return {
        path: `/${this.langPrefix}${pageSlug}/${slug}`
      };
    }
  }
};
